function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "C7D5D232-5458-4F6E-A87E-2EA977CE25C9");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Uploader",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Modules/menu-close",
  transform: "translate(-14.000000, -77.000000)",
  fill: "#63CEDA"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/arrow-right",
  transform: "translate(14.363636, 77.454545)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.232833,2.50596646 C8.5759819,2.11239305 9.17321333,2.0715159 9.56678674,2.41466481 C9.92100281,2.72349882 9.98953491,3.23813968 9.74954361,3.62489453 L9.65808839,3.74861855 L4.58533031,9.56680037 C4.24358602,9.95876277 3.65905013,9.99537365 3.27201894,9.67585504 L3.16227502,9.56931479 L-1.94678508,3.75113297 C-2.29132266,3.35877465 -2.25255628,2.76140249 -1.86019796,2.41686491 C-1.50707546,2.10678109 -0.987891763,2.10717347 -0.636418354,2.39638201 L-0.525929892,2.50345204 L3.86909706,7.50983796 L8.232833,2.50596646 Z",
  id: "Path-2-Copy-8",
  transform: "translate(3.854552, 6.036377) rotate(-90.000000) translate(-3.854552, -6.036377) "
}))));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "13px",
    viewBox: "0 0 9 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.ca4d74f3.svg";
export { ForwardRef as ReactComponent };